export const inActiveWrapper = parentClass => {
  var parent = document.getElementsByClassName(parentClass)
  parent[0].classList.add('inActive')
}
